// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import cn from 'classnames';
import Icon_chevron_down from '../../img/icons/24/chevron_down.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../lib/button';
import styles from './faq.module.less';

interface i_question {
    quest: string,
    ans: string | JSX.Element | Array<{
        name: string,
        url: string
    }>
}

interface i_faq_quest_props extends i_question {
    is_continent?: boolean;
    link?: string;
}

const Faq_question = (props: i_faq_quest_props)=>{
    const {theme} = useContext(Settings_context);
    const [opened, set_opened] = useState(false);
    const history = useHistory();
    const on_click = e=>{
        if (!props?.link)
            set_opened(!opened);
        else if (props?.link)
        {
            handle_click(e);
            history.push(props.link);
        }
        else return;
    };
    const continent_url =
        `/proxy-location/${props.quest.toLowerCase().replace(/\s+/g, '-')}`;
    const handle_click = e=>{
        e.stopPropagation();
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    const renderAnswer = ()=>{
        if (typeof props.ans==='string')
        {
            return <div className={styles.dangerous}
              dangerouslySetInnerHTML={{__html: props.ans}}
            />;
        }
        else if (Array.isArray(props.ans))
        {
            return <div className={styles.country_list}>
              {props.ans.map(country=>
                <Link
                  key={country.name}
                  to={country.url}
                  className={cn(styles.country_link, theme.p14, theme.P)}
                  onClick={handle_click}>
                  {country.name}
                </Link>
              )}
            </div>;
        }
        else if (React.isValidElement(props.ans))
            return props.ans;
        else if (typeof props.ans==='object')
        {
            return <div className={cn(styles.dangerous)}>
              {JSON.stringify(props.ans)}
            </div>;
        }
        return null;
    };
    return <div className={cn(styles.faq_item, opened && styles.opened)}
      onClick={on_click}>
      <div className={styles.title_line}>
        <p className={cn(styles.p16, theme.med)}>
          {props.is_continent && opened ?
            <Link to={continent_url} onClick={handle_click}>
              {props.quest}
            </Link>
            : props?.link ?
            <Link to={props.link} onClick={handle_click}>
              {props.quest}
            </Link> :
            props.quest
          }
        </p>
          {!props?.link && <Icon_chevron_down />}
      </div>
      <div className={styles.faq_text}>
        {renderAnswer()}
      </div>
    </div>;
};

interface i_faq_section_props {
    color?: 'default' | 'transparent';
    title?: string;
    cls?: string;
    custom_questions?: Array<i_question>;
}

const Faq_section = (props: i_faq_section_props)=>{
    const {title, custom_questions, cls, color = 'default'} = props;
    return <div className={cn(styles.faq_section, cls, styles[color])}>
      {title && <h2 className={styles.title}>{title || 'Some FAQs'}</h2>}
      {custom_questions.map((question, index)=>
        <Faq_question
          key={index}
          quest={question.quest}
          ans={question.ans}
          is_continent={Array.isArray(question.ans)}/>
      )}
    </div>;
};

type t_questions = Array<i_question>;

export interface i_faq_props {
    title?: string;
    questions_shown?: number;
    get_questions: (t?: any)=>t_questions;
    with_title?: boolean;
}

export const Faq = (props: i_faq_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, questions_shown, get_questions, with_title = true} = props;
    const faq_title = title || 'FAQ';
    const items = get_questions(theme);
    const [shown, set_shown] = useState(questions_shown || items.length);
    const shown_faq = items.slice(0, shown);
    const show_all = ()=>set_shown(items.length);
    return <>
      <Faq_section title={with_title ? faq_title : undefined}
        custom_questions={shown_faq}/>
      {questions_shown && shown < items.length && <Button color="tertiary"
        cls={styles.show_btn} on_click={show_all}
        caption={<>Show all FAQs <Icon_chevron_down/></>}
      />}
    </>;
};
